import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { AddOrDeleteOffer } from '../../Components';
import { JobSeekerService, SecurityApiService } from '../../Services';

interface IAddOrDeleteOfferProps {
    connectionPageUrl: string;
    isAuthenticated: string;
    reference: string;
    type: string;
    dictOfferDelete: string;
    dictOfferSave: string;
}

interface IAddOrDeleteOfferState {
    isSaved: boolean;
}

const SUPPORTED_TYPES = ['Select', 'DirectOnline', 'Hrxml'];

export class AddOrDeleteOfferWidget extends Component<
    IAddOrDeleteOfferProps,
    IAddOrDeleteOfferState
> {
    private offerPending = false;
    // Instance properties so they can unregister themselves by reference
    private readonly addOfferOnceUserIsAuthenticated: () => void;
    private readonly setOfferStateListener: () => void;

    constructor(props: IAddOrDeleteOfferProps) {
        super(props);

        this.state = { isSaved: false };

        this.addOfferOnceUserIsAuthenticated = () => {
            if (SecurityApiService?.hasAccessToBasketOffer()) {
                SecurityApiService.removeOnChangeListener(
                    this.addOfferOnceUserIsAuthenticated
                );
                this.offerPending = false;
                void JobSeekerService.addOffer(
                    this.props.reference,
                    this.props.type,
                    SecurityApiService.dossierId!
                );
            }
        };

        // Wrap async method in void wrapper so listener receives () => void
        this.setOfferStateListener = () => {
            void this.setOfferState();
        };
    }

    componentDidMount() {
        SecurityApiService.addOnChangeListener(this.setOfferStateListener);
    }

    componentWillUnmount() {
        SecurityApiService.removeOnChangeListener(this.setOfferStateListener);
    }

    async setOfferState() {
        if (SecurityApiService?.hasAccessToBasketOffer()) {
            try {
                const isSaved = await JobSeekerService.isOfferInBasket(
                    SecurityApiService.dossierId!,
                    this.props.reference,
                    this.props.type
                );
                this.setState({ isSaved });
            } catch (e) {
                if (!(e instanceof DOMException) || e.name !== 'AbortError') {
                    throw e;
                }
            }
        }
    }

    async handleClick() {
        if (this.props.isAuthenticated !== 'true') {
            window.location.assign(
                `/account/login?returnUrl=${encodeURIComponent(
                    `${window.location.pathname}${window.location.search}${window.location.hash}`
                )}`
            );
            return;
        }

        if (!this.state.isSaved) {
            await JobSeekerService.addOffer(
                this.props.reference,
                this.props.type,
                SecurityApiService.dossierId ?? 0
            );
            this.setState({ isSaved: true });
        } else {
            await JobSeekerService.deleteOffer(
                this.props.reference,
                this.props.type,
                SecurityApiService.dossierId ?? 0
            );
            this.setState({ isSaved: false });
        }
    }

    render() {
        if (!SUPPORTED_TYPES.includes(this.props.type)) {
            return <></>;
        }

        return (
            <AddOrDeleteOffer
                className={this.state.isSaved ? ' active' : ''}
                label={
                    this.state.isSaved
                        ? this.props.dictOfferDelete
                        : this.props.dictOfferSave
                }
                onClick={() => {
                    void this.handleClick();
                }}
            />
        );
    }
}

WidgetHelper.register(AddOrDeleteOfferWidget, 'add-or-delete-offer-widget');
